import { ScrollTrigger } from 'gsap/ScrollTrigger';

/* ====================================
# キャッチコピー追従アニメーション
==================================== */
export const initCatchCopyFollowAnimation = () => {
  const catchInner = document.querySelector('.p-top-hero__catch-inner');
  const heroSection = document.querySelector('.p-top-hero');
  const heroBottom = document.querySelector('.p-top-hero__bottom');

  if (!catchInner || !heroSection) return;

  ScrollTrigger.create({
    trigger: catchInner,
    pin: catchInner,
    start: 'center center-=50px', // 50px上にオフセット
    endTrigger: () => {
      if (window.innerWidth <= 768 && heroBottom) {
        return heroBottom;
      }
      return heroSection;
    },
    end: () => {
      const catchHeight = catchInner.offsetHeight;
      if (window.innerWidth <= 768 && heroBottom) {
        return `top center+=${catchHeight / 2 - 50}px`; // オフセット分調整
      }
      return `bottom center+=${catchHeight / 2 - 50}px`; // オフセット分調整
    },
    pinSpacing: false,
  });
};